import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InvoiceRevenueEditData, InvoiceRevenueEditRequest } from '../models/invoice-revenue-edit.model';
import { InvoiceRepository } from '../interfaces/invoice-repository.interface';

@Injectable()
export class UpdateInvoiceRevenueUseCase {
  constructor(private readonly repository: InvoiceRepository) {}

  execute(request: InvoiceRevenueEditRequest): Observable<InvoiceRevenueEditData> {
    return this.repository.updateRevenue(request);
  }
}

